/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_BasicInputs */

const en_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic`)
};

const de_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basis`)
};

const fr_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base`)
};

const es_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Básico`)
};

const it_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base`)
};

const nl_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basis`)
};

const pl_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podstawowy`)
};

const fi_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perus`)
};

const da_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundlæggende`)
};

const sv_pricing_compare_basic = /** @type {(inputs: Pricing_Compare_BasicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundläggande`)
};

/**
* | output |
* | --- |
* | "Basic" |
*
* @param {Pricing_Compare_BasicInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_basic = /** @type {((inputs?: Pricing_Compare_BasicInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_BasicInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_basic(inputs)
	if (locale === "fr") return fr_pricing_compare_basic(inputs)
	if (locale === "es") return es_pricing_compare_basic(inputs)
	if (locale === "it") return it_pricing_compare_basic(inputs)
	if (locale === "nl") return nl_pricing_compare_basic(inputs)
	if (locale === "pl") return pl_pricing_compare_basic(inputs)
	if (locale === "fi") return fi_pricing_compare_basic(inputs)
	if (locale === "da") return da_pricing_compare_basic(inputs)
	if (locale === "sv") return sv_pricing_compare_basic(inputs)
	return en_pricing_compare_basic(inputs)
});